import { useTranslation } from 'react-i18next';

import { Chip } from 'common/components/Chip';
import { IBudgetRequestStatus } from 'graphql/types';
import { BUDGET_REQUEST_STATUS_CONFIG } from 'budget/constants/budgetApprovals';

interface IProps {
    status: IBudgetRequestStatus;
}

export const BudgetApprovalStatusChip = ({ status }: IProps) => {
    const [translate] = useTranslation();

    const { chipColor, labelKey } = BUDGET_REQUEST_STATUS_CONFIG[status];

    return (
        <Chip bgColor={chipColor} label={translate(labelKey)} size="small" />
    );
};
